import { render } from "./BloodUnitsTab.vue?vue&type=template&id=6fbe7c14"
import script from "./BloodUnitsTab.vue?vue&type=script&lang=js"
export * from "./BloodUnitsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__